import Dropzone from 'dropzone';

class Uploader {
  constructor({ id, url, clickElement, options }) {
    const children = [];

    console.log(options);

    if (clickElement) {
      Array.from(clickElement.children).forEach(i => {
        children.push(i);
      });
    }

    const headers = Object.assign(
      {},
      {
        Accept: '*/*',
        'Cache-Control': '',
        'X-Requested-With': '',
      },
    );

    const dropzoneOptions = Object.assign(
      {},
      {
        method: 'POST',
        parallelUploads: 1,
        maxFilesize: 10,           // MB
        clickable: true,
        acceptedFiles: 'image/*',
        paramName: 'file',
        dictMaxFilesExceeded: '',
        dictFileTooBig: '파일크기 초과 (최대 {{maxFilesize}}MB)',
        dictInvalidFileType: '업로드 불가한 유형의 파일입니다.',
        autoProcessQueue: true,
        resizeMethod: 'contain',
        createImageThumbnails: false,
        previewsContainer: false,
      },
      options,
      { url },
    );

    console.log(dropzoneOptions);

    this.uploader = new Dropzone(id, dropzoneOptions);
  }

  on({
    onAddedfile,
    onAddedfiles,
    onError,
    onSending,
    onUploadProgress,
    onSuccess,
    onCanceled,
    onThumbnail,
    onQueueComplete,
    onComplete,
    onMaxFilesExceeded,
  }) {
    const self = this;

    onAddedfile && this.uploader.on('addedfile', onAddedfile);
    onAddedfiles && this.uploader.on('addedfiles', files => {
      const newFiles = [...files].filter(file => file.status !== 'error');
      onAddedfiles(newFiles);
    });
    onError && this.uploader.on('error', onError);
    onSending && this.uploader.on('sending', onSending);
    onUploadProgress && this.uploader.on('uploadprogress', onUploadProgress);
    onSuccess && this.uploader.on('success', onSuccess);
    onCanceled && this.uploader.on('canceled', onCanceled);
    onThumbnail && this.uploader.on('thumbnail', onThumbnail);
    onQueueComplete && this.uploader.on('queuecomplete', onQueueComplete);
    this.uploader.on('complete', file => {
      self.uploader.removeFile(file);
      onComplete && onComplete(file);
    });

    onMaxFilesExceeded && this.uploader.on('maxfilesexceeded', onMaxFilesExceeded);
  }

  removeFile(file) {
    return this.uploader.removeFile(file);
  }

  processQueue() {
    this.uploader.processQueue();
  }

  getQueuedFiles() {
    return this.uploader.getQueuedFiles();
  }

  getUploadingFiles() {
    return this.uploader.getUploadingFiles();
  }

  getRejectedFiles() {
    return this.uploader.getRejectedFiles();
  }

  enable() {
    this.uploader.enable();
  }

  disable() {
    this.uploader.disable();
  }

  off() {
    this.uploader.off();
  }

  destroy() {
    this.uploader.destroy();
  }
}

export default Uploader;
